import React from "react";
import { Col, Row } from "react-bootstrap";
import { SiMicrosoftazure, SiNextdotjs, SiSupabase } from "react-icons/si";
import C from "../../Assets/TechIcons/C++.svg";
import Javascript from "../../Assets/TechIcons/Javascript.svg";
import Node from "../../Assets/TechIcons/Node.svg";
import ReactIcon from "../../Assets/TechIcons/React.svg";
import Java from "../../Assets/TechIcons/Java.svg";
import Python from "../../Assets/TechIcons/Python.svg";
import Typescript from "../../Assets/TechIcons/Typescript.svg";
import Git from "../../Assets/TechIcons/Git.svg";
import Firebase from "../../Assets/TechIcons/Firebase.svg";
import Redis from "../../Assets/TechIcons/Redis.svg";
import Docker from "../../Assets/TechIcons/Docker.svg";
import SQL from "../../Assets/TechIcons/SQLDefault.svg";
import Kubernates from "../../Assets/TechIcons/Kubernates.svg";
import Tailwind from "../../Assets/TechIcons/Tailwind.svg";
import MUI from "../../Assets/TechIcons/MUI.svg";
import Postman from "../../Assets/TechIcons/Postman.svg";
import AWS from "../../Assets/TechIcons/AWS.svg";

const techStacks = [
  { name: "Javascript", url: "https://developer.mozilla.org/en-US/docs/Web/JavaScript", image: Javascript },
  { name: "Typescript", url: "https://www.typescriptlang.org/", image: Typescript },
  { name: "Node.Js", url: "https://nodejs.org/", image: Node },
  { name: "React.Js", url: "https://react.dev/", image: ReactIcon },
  { name: "Next.js", url: "https://nextjs.org/", icon: <SiNextdotjs fontSize="24px" /> },
  { name: "Git", url: "https://git-scm.com/", image: Git },
  { name: "Firebase", url: "https://firebase.google.com/", image: Firebase },
  { name: "Redis", url: "https://redis.io/", image: Redis },
  { name: "Docker", url: "https://www.docker.com/", image: Docker },
  { name: "Kubernetes", url: "https://kubernetes.io/", image: Kubernates },
  { name: "SQL", url: "https://www.postgresql.org/docs/", image: SQL },
  { name: "Python", url: "https://www.python.org/", image: Python },
  { name: "Java", url: "https://www.java.com/", image: Java },
  { name: "C++", url: "https://isocpp.org/", image: C },
  { name: "Tailwind CSS", url: "https://tailwindcss.com/", image: Tailwind },
  { name: "Material UI", url: "https://mui.com/", image: MUI },
  { name: "Postman", url: "https://www.postman.com/", image: Postman },
  { name: "AWS", url: "https://aws.amazon.com/", image: AWS, imageClassName: "tech-icon-images" },
  {
    name: "Azure",
    url: "https://azure.microsoft.com/",
    icon: <SiMicrosoftazure fontSize="26px" color="#0078D4" />,
  },
  {
    name: "Supabase",
    url: "https://supabase.com/",
    icon: <SiSupabase fontSize="26px" color="#3ECF8E" />,
  },
];

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {techStacks.map(({ name, url, image, icon, imageClassName }) => (
        <Col xs={4} md={2} className="tech-icons" key={name}>
          <a
            className="tech-icons-link"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Learn more about ${name}`}
          >
            {image ? <img src={image} alt="" className={imageClassName} /> : icon}
            <span className="tech-icons-text">{name}</span>
          </a>
        </Col>
      ))}
    </Row>
  );
}

export default Techstack;
